module.exports = __webpack_public_path__ + "media/images/Jessica_Sabrowsky-339203a887d1e7af700c3903c16a6fea.jpeg";